module.exports = __webpack_public_path__ + "img/plus-circle.619b96fa.svg";